import React from 'react'
import SvgIcon from '@mui/material/SvgIcon'
import { SVGIconProps } from 'commonTypes'

const TargetIcon: React.FC<SVGIconProps> = ({ fill, ...props }) => {
    return (
        <SvgIcon viewBox="0 0 24 24" {...props}>
            <g
                stroke="none"
                strokeWidth="1"
                fill="none"
                fillRule="evenodd"
                opacity="0.5"
            >
                <path
                    fill={fill ?? '#09293E'}
                    d="M12 2a10 10 0 1 0 10 10h-2a8 8 0 1 1-8-8V2Zm0 4a6 6 0 1 0 6 6h-2a4 4 0 1 1-4-4V6Zm7.71-3.71-2 2H15v2.71l-2.71 2.71a2 2 0 1 0 2 2L17 9h2.71l2-2-2.29-.71.29-2.29-2.29.29.29-2.29Z"
                />
            </g>
        </SvgIcon>
    )
}

export default TargetIcon